var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    top: 15,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.75 0.5H0V20.5H15V6.75H8.75V0.5ZM10 0.5V5.5H15L10 0.5ZM4.375 10.5H10.625H11.25V11.75H10.625H4.375H3.75V10.5H4.375ZM4.375 13H10.625H11.25V14.25H10.625H4.375H3.75V13H4.375ZM4.375 15.5H10.625H11.25V16.75H10.625H4.375H3.75V15.5H4.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.d808f174139b7894730108816cf48777.svg";
export { ForwardRef as ReactComponent };